//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Fragment } from "vue-fragment";
import RichTextEditor from "@Shared/utils/rich-text-editor";
import { isObject } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "NoteArgument",
  components: {
    Fragment
  },
  props: {
    value: {
      type: [String, Object],
      default: ""
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const localValue = isObject(this.value) ? "" : this.value;
    return {
      localValue,
      editor: null
    };
  },
  watch: {
    value(newValue) {
      if (newValue !== this.localValue) {
        this.localValue = newValue;
        this.editor.setHTML(this.localValue);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      $(".note-codable").attr("id", "note");
    });
  },
  methods: {
    init() {
      const target = $(this.$refs.noteField);
      this.editor = new RichTextEditor(target, {
        airMode: true,
        height: "10vw",
        substitutionHints: false,
        showMergeTags: false,
        loadPreferences: false,
        callbacks: {
          onChange: this.handleEditorChange
        }
      });
      this.$nextTick(() => {
        target.next(".note-editor").addClass("trigger-select form-control h-100");
      });
    },
    handleEditorChange(contents, value) {
      if (this.localValue !== value) {
        this.localValue = value;
        this.$emit("input", this.localValue);
      }
    }
  }
});